export const blockIconsNavigationEast = (
	<span className='material-symbols-outlined'>east</span>
);
